/**
 * Utility to convert object keys with true values into a comma-separated string.
 * 1. Get the entries [key, value]
 * 2. Filter for pairs where the value is true
 * 3. Map to get only the keys
 * 4. Join them with a comma and a space
 * @param {Object} obj - The source object with boolean values.
 * @returns {string} - A comma-separated string of keys, or an empty string if input is invalid.
 */
export const getTrueKeysAsCSV = (obj) => {
	// Handles null, undefined, or non-object types
	if (!obj || typeof obj !== 'object') {
		return '';
	}

	return Object.entries(obj)
		.filter(([_, value]) => value === true)
		.map(([key]) => key)
		.join(', ');
};
